/**
 * Constructs shipment filters based on the user's configuration
 * @param {Object} user - The user object containing information such as funders, routes, programs, and roles.
 * @returns {Object} - The shipment filters based on the user's configuration
*/
module.exports.getUserShipmentFilters = function (user) {
  // Get user filters
  const { funders = [], routes = [], programs = [], roles = [] } = user
  const isDriver = roles.includes('userRole:psm-driver')

  const options = {
    funder_id: funders,
    program_id: programs,
    route_id: routes
  }

  // Go through options and delete empty options
  // This means it'd not be included in the shipments filter
  for (let option in options) {
    if (options[option].length === 0) delete options[option]
  }

  // Filter by status based on users drivers only start seeing from packed
  if (isDriver) {
    options.status = ['packed', 'sent', 'arrived', 'received']

    // CRITICAL FIX: Drivers should ONLY see shipments assigned to their routes.
    // If a driver has no routes assigned, they should see NO shipments (not all shipments).
    // This prevents RMS shipments (which have route_id = null) from appearing on driver dashboards.
    // Defensive check: handle cases where routes might be undefined, null, or empty array
    // (some drivers may not have the routes property in their documents)
    if (!routes || routes.length === 0) {
      // Set route_id to empty array so the query filters to show nothing
      // (an empty IN clause will match no rows)
      options.route_id = []
    }
  }

  return options
}
